import { render, staticRenderFns } from "./ReviewSuccess.vue?vue&type=template&id=136bb608&scoped=true&"
import script from "./ReviewSuccess.vue?vue&type=script&lang=js&"
export * from "./ReviewSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSuccess.vue?vue&type=style&index=0&id=136bb608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136bb608",
  null
  
)

export default component.exports